import { Plugin } from '@nuxt/types'
import Toaster from '~/utils/Toaster'

const toaster: Plugin = (context, inject) => {
  inject('toaster', new Toaster())
}

export default toaster
